/**
 * DevExtreme (esm/ui/scroll_view.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ScrollView from "../__internal/ui/scroll_view/m_scroll_view";
export default ScrollView;
